export const DEFAULT_MENU_ITEMS = {
    menuSettings: {
        menuBackgroundcolor: '',
        menuHovercolor: '',
        menualignment: '',
        menuToplineColor: '',
        menuBottomlineColor: '',
        menuToplineThickness: '',
        menuBackgroundImage: '',
        menuBottomlineThickness: '',
        menuRightIconcolor: '',
        menuRightIconbackgroundcolor: '',
    },
    menuItems: [
        {
            "id": 1,
            "expanded": true,
            "name": "Home",
            "isStatic": false,
            "isEnabled": true,
            "anchorLink": "/",
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "subMenuBackgroundColor": "",
            "isSubmenu": false,
            "subMegaMenu": true,
            "subMenus": false,
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            },
            "subMenuitems": []
        },
        {
            "id": 2,
            "name": "Blogs",
            "isStatic": false,
            "expanded": true,
            "anchorLink": "/blogs",
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": true,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": false,
            "subMenus": true,
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            },
            "subMenuitems": [
                {
                    "id": 2,
                    "name": "Test Link",
                    "anchorLink": "/"
                }
            ]
        },
        {
            "id": 3,
            "name": "Categories",
            "staticName": "categories",
            "isEditable": false,
            "anchorLink": "",
            "isStatic": true,
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": true,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            },
            "subMenuitems": []
        },
        {
            "id": 4,
            "name": "Static pages",
            "staticName": "staticPage",
            "anchorLink": "",
            "isStatic": true,
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": true,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "subMenuitems": [],
            "submegaMenuitems":{
                imageList: [],
                menuItemsLi: []
            }
        },
        {
            "id": 5,
            "name": "Contact Us",
            "staticName": "contactUs",
            "isStatic": false,
            "anchorLink": "/contact",
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": false,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "subMenuitems": [],
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            }
        },
        {
            "id": 6,
            "name": "Orders",
            "staticName": "orders",
            "isStatic": true,
            "anchorLink": "/orders",
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": false,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "subMenuitems": [],
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            }
        },
        {
            "id": 10,  // TODO: validate id with VOUCHER AND GIFCARD BALANCE
            "name": "Star Award",
            "staticName": "rewardprogram",
            "isStatic": true,
            "anchorLink": "/rewardprogram",
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": false,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "menuFontcolor": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "menuItemBgColor": "",
            "menuItemBgHoverColor": "",
            "menuItemFontColor": "",
            "menuItemFontHoverColor": "",
            "subMenuitems": [],
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            }
        },
        {
            "id": 8,
            "name": "Gift Card Balance",
            "staticName": "giftcardbalance",
            "isStatic": true,
            "anchorLink": "/giftcardbalance",
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": false,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "menuFontcolor": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "menuItemBgColor": "",
            "menuItemBgHoverColor": "",
            "menuItemFontColor": "",
            "menuItemFontHoverColor": "",
            "subMenuitems": [],
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            }
        },
        {
            "id": 9,
            "name": "Voucher Balance",
            "staticName": "voucherbalance",
            "isStatic": true,
            "anchorLink": "/voucherbalance",
            "expanded": false,
            "isEnabled": true,
            "fontName": "",
            "fontColor": "",
            "fontSize": "",
            "isSubmenu": false,
            "subMenufontName": "",
            "subMenufontColor": "",
            "subMenufontSize": "",
            "menuFontcolor": "",
            "subMenuBackgroundColor": "",
            "subMegaMenu": true,
            "subMenus": false,
            "menuItemBgColor": "",
            "menuItemBgHoverColor": "",
            "menuItemFontColor": "",
            "menuItemFontHoverColor": "",
            "subMenuitems": [],
            "submegaMenuitems": {
                imageList: [],
                menuItemsLi: []
            }
        },
    ]
}

export const REPORT_BUILDER_PATH_NAME = 'report-builder';
export const REPORT_VIEWER_PATH_NAME = 'report-viewer';